/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_2_TitleInputs */

const en_gc_search_guides_gridcraft_vs_excel_sections_2_title = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When to keep Excel in the workflow`)
};

const zh_gc_search_guides_gridcraft_vs_excel_sections_2_title = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`哪些情况应保留 Excel 工作流程`)
};

/**
* | output |
* | --- |
* | "When to keep Excel in the workflow" |
*
* @param {Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_2_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_vs_excel_sections_2_title = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_2_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_2_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_vs_excel_sections_2_title(inputs)
	return zh_gc_search_guides_gridcraft_vs_excel_sections_2_title(inputs)
});
export { gc_search_guides_gridcraft_vs_excel_sections_2_title as "gc.search_guides.gridcraft_vs_excel.sections.2.title" }